<template>
  <div class="shop-flings">
    <div justify="center">
      <!-- Fling Categories -->
      <div v-if="status === 'loaded'" class="d-flex justify-left py-8">
        <div style="width: 100%">
          <template v-if="userData.trailing">
            <v-alert dense border="left" type="primary">
              <h3 class="mb-2">FREE Trial Period<br /></h3>
              Please enjoy your free trial Fling "The Test Drive"!<br />
              If you love what you see and can't wait to redeem your Fling tokens,
              <router-link :to="{ name: 'end_trail' }" class="btn btn-primary white--text">
                please click this link</router-link
              >
              to see how you can start your subscription right away!
            </v-alert>
          </template>

          <div class="font-weight-medium">Fling Categories</div>

          <div class="fling-categories">
            <div
              v-for="category in fling_categories"
              :key="category.titl"
              class="fling-category"
              :class="{ selected: category.id === selected_category.id }"
              @click="selectCategory(category)"
            >
              <div class="fling-category-photo">
                <img :src="category.photo" />
              </div>
              <div class="fling-category-title">
                {{ category.title }}
              </div>
            </div>
          </div>

          <div v-if="selected_category.id" class="mt-8">
            <div class="font-weight-medium">
              {{ selected_category.title }}
            </div>

            <!-- Flings For Category -->
            <div class="category-flings">
              <div
                v-for="fling in selected_category.flings"
                :key="fling.title"
                class="category-fling"
                @click="selected_fling = fling"
              >
                <div class="category-fling-photo">
                  <img :src="fling.photo" />
                </div>
                <div class="category-actions">
                  <div class="category-fling-title">
                    {{ fling.title }}
                  </div>
                  <div class="category-fling-add-to-cart">
                    <template v-if="fling.purchased">
                      <v-btn color="primary" disabled depressed>Purchased</v-btn>
                    </template>
                    <template v-else>
                      <v-btn
                        :color="cart.includes(fling.id) ? 'primary' : ''"
                        :disabled="userData.trailing"
                        @click.stop="addOrRemoveFromCart(fling)"
                      >
                        <template v-if="cart.includes(fling.id)"
                          >Added <v-icon right>mdi-check</v-icon></template
                        >
                        <template v-else> Add to cart <v-icon right>mdi-plus</v-icon> </template>
                      </v-btn>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Cart Fab Button -->
        <v-fab-transition>
          <v-btn
            v-show="cart.length"
            evalation="2"
            fab
            fixed
            bottom
            right
            @click="show_cart = true"
          >
            <v-badge
              :color="cart.length > userData.unused_tokens ? 'error' : 'primary'"
              :content="cart.length"
            >
              <v-icon>mdi-cart</v-icon>
            </v-badge>
          </v-btn>
        </v-fab-transition>

        <!-- Fling Pop-Up -->
        <v-dialog v-model="modal" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="primary" tile>
              <v-btn icon dark @click="selected_fling = {}">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ selected_fling.title }}</v-toolbar-title>
            </v-toolbar>

            <v-img class="show-fab-button" height="250" :src="selected_fling.photo">
              <v-btn
                fab
                absolute
                bottom
                right
                @click.stop="addOrRemoveFromCart(selected_fling)"
                :color="cart.includes(selected_fling.id) ? 'primary' : ''"
                :disabled="selected_fling.purchased || userData.trailing"
                ><v-icon v-if="cart.includes(selected_fling.id)">mdi-minus</v-icon
                ><v-icon v-else>mdi-plus</v-icon></v-btn
              >
            </v-img>

            <v-card-text class="mt-8">
              <div v-html="selected_fling.new_teaser"></div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>

      <!-- Cart -->
      <v-dialog v-model="show_cart" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary" tile class="mb-8">
            <v-btn icon dark @click="show_cart = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Cart</v-toolbar-title>
          </v-toolbar>

          <div class="cart-container px-4" style="max-width: 700px; margin: 0 auto">
            <template v-if="cart.length === 0">
              <v-alert dense border="left" type="warning">
                You must have at least one Fling in your cart to redeem a Token.
              </v-alert>

              <div class="text-center">
                <v-btn color="light" class="mt-4" @click="show_cart = false"
                  >Continue Shopping</v-btn
                >
              </div>
            </template>

            <template v-if="cart.length > userData.unused_tokens">
              <v-alert dense border="left" type="warning">
                You have selected more Flings than Available Tokens.
              </v-alert>

              <div>Your options:</div>
              <ul class="mt-3">
                <router-link :to="{ name: 'purchase_tokens' }"
                  >Purchase Individual Tokens</router-link
                >
              </ul>
              <ul class="mb-6 mt-1">
                <router-link :to="{ name: 'edit_package' }">Upgrade Your Subscription</router-link>
              </ul>
            </template>

            <div class="cart">
              <div v-for="item in cart_items" :key="`item-${item.id}`" class="cart-item">
                <div class="cart-item-photo">
                  <img :src="item.photo" />
                </div>
                <div>
                  <div>
                    {{ item.title }}
                  </div>
                  <div>
                    <div class="text-decoration-underline" style="cursor: pointer">
                      <span @click.stop="addOrRemoveFromCart(item)"> Remove </span>
                    </div>
                  </div>
                </div>
                <v-btn fab text color="primary">
                  <v-icon>mdi-tag</v-icon>
                </v-btn>
              </div>
            </div>

            <template v-if="cart.length > 0 && cart.length <= userData.unused_tokens">
              <v-divider></v-divider>

              <div class="mt-6">
                <div class="grey--text text--darken-2">Order Summary</div>
                <div class="d-flex justify-space-between my-2 px-4">
                  <div>Available Tokens</div>
                  <div>{{ userData.unused_tokens }}</div>
                </div>
                <div class="d-flex justify-space-between my-2 px-4">
                  <div>Flings Selected</div>
                  <div>-{{ cart.length }}</div>
                </div>

                <div class="grey--text text--darken-2 mt-6">After Order Summary</div>
                <div class="d-flex justify-space-between my-2 px-4">
                  <div>Remaining Tokens</div>
                  <div>{{ userData.unused_tokens - cart.length }}</div>
                </div>
              </div>

              <div v-if="redeemErrors !== ''" class="py-5">
                <v-alert color="error" dark>
                  {{ redeemErrors }}
                </v-alert>
              </div>

              <div class="mt-10 py-5">
                <v-btn color="primary" large block :disabled="redeeming" @click="redeemTokens"
                  >Redeem Tokens
                  <v-progress-circular
                    v-if="redeeming"
                    size="20"
                    width="2"
                    indeterminate
                    class="ml-2"
                  />
                </v-btn>
              </div>

              <div class="mt-10">
                <ul>
                  <li class="mb-2">Fling Tokens do not expire and can accumulate.</li>
                  <li class="mb-2">
                    Once redeemed, you can find your new Flings in your Dashboard. Please note that
                    you may need to refresh the page to view all of your Flings, or verify your
                    payment information is correct.
                  </li>
                  <li class="mb-2">All Fling sales and redemptions are FINAL.</li>
                </ul>
              </div>
            </template>
          </div>
        </v-card>
      </v-dialog>

      <!-- Loading -->
      <div v-if="status === 'loading'" class="d-flex justify-center">
        <v-progress-circular size="50" width="2" indeterminate class="mt-5" />
      </div>

      <!-- Error -->
      <div v-if="status === 'error'" class="d-flex justify-center">
        <v-alert dense border="left" type="warning">
          Failed to load Fling Categories. Please check your connection and try again.
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: "loading",
      fling_categories: [],
      selected_category: {},
      modal: false,
      selected_fling: {},
      show_cart: false,
      cart: [],
      cart_items: [],
      redeeming: false,
      redeemErrors: "",
    };
  },

  watch: {
    selected_fling() {
      if (this.selected_fling.id) {
        this.modal = true;
      } else {
        this.modal = false;
      }
    },
  },

  async created() {
    await this.refresh();
    this.loadFlingCategories();
  },

  methods: {
    async loadFlingCategories() {
      this.status = "loading";
      this.error = "";

      const responseData = await this.api({
        url: "fling_categories",
      });

      if (responseData.status === 200) {
        this.status = "loaded";
        this.fling_categories = responseData.body;
        this.selected_category = this.fling_categories[0];
      } else {
        this.status = "error";
      }
    },

    selectCategory(category) {
      this.selected_category = category;
    },

    addOrRemoveFromCart(fling) {
      if (this.cart.includes(fling.id)) {
        this.cart.splice(this.cart.indexOf(fling.id), 1);
        this.cart_items.splice(this.cart_items.indexOf(fling), 1);
      } else {
        this.cart.push(fling.id);
        this.cart_items.push(fling);
      }

      this.selected_fling = {};
    },

    async redeemTokens() {
      if (this.redeeming) {
        return;
      }

      this.redeeming = true;
      this.redeemErrors = "";

      const responseData = await this.api({
        url: `users/${this.userData.id}/redeem_tokens/`,
        method: "POST",
        json: {
          flings: this.cart,
        },
      });

      await this.refresh();

      if (responseData.status === 200) {
        this.$router.push({ name: "home", params: { new_flings: true } });
      } else if (responseData.status === 400) {
        this.redeeming = false;
        this.redeemErrors = responseData.body;
      } else {
        this.redeeming = false;
        this.redeemErrors = "Failed to redeem tokens. Please check your connection and try again.";
      }
    },
  },
};
</script>

<style lang="scss">
.shop-flings {
  font-family: "Raleway", Helvetica, Arial, Lucida, sans-serif;
  padding: 0 12px;
}

.fling-categories {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  width: 100vw;
  height: 250px;
  margin: 0 -12px;
  padding: 0 12px;

  gap: 20px;

  // *::-webkit-scrollbar {
  //   display: none;
  // }

  .fling-category {
    flex-shrink: 0;
    width: 180px;
    height: 180px;
    margin: 4px;

    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    cursor: pointer;

    &.selected {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);

      img {
        filter: none !important;
      }

      .fling-category-title {
        font-weight: bold;
      }
    }

    .fling-category-photo {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        filter: grayscale(1);
      }
    }

    .fling-category-title {
      position: absolute;
      top: calc(100% + 10px);
    }
  }
}

.category-flings {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media (min-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .category-fling {
    flex-shrink: 0;
    width: 100%;
    height: auto;
    margin: 10px 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;

    cursor: pointer;

    &:hover,
    &:active {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }

    .category-fling-photo {
      display: flex;
      width: 100%;
      height: 100%;
      overflow: hidden;

      img {
        width: 100%;
        object-fit: cover;
      }
    }

    .category-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 30px 20px;
      font-weight: bold;
    }
  }
}

.cart-container {
  overflow-y: scroll;
}

.cart {
  .cart-item {
    display: grid;
    grid-template-columns: 100px 1fr 50px;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;

    .cart-item-photo {
      width: 100px;
      height: 100px;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.show-fab-button {
  overflow: initial;
}
</style>
